/**
 * Deprecated layout spacing values. Do not use
 *
 * @deprecated use a value within {UitkLayoutSpaceMap}
 */
const EGDSLayoutSpaceDeprecatedValuesMap = [
    ['half', 'gap-half'],
    ['one', 'gap-one'],
    ['two', 'gap-two'],
    ['three', 'gap-three'],
    ['four', 'gap-four'],
    ['six', 'gap-six'],
    ['twelve', 'gap-twelve'],
];
/**
 * Layout spacing values
 *
 */
const EGDSLayoutSpaceMap = [
    ['xsmall', 'gap-xsmall'],
    ['small', 'gap-small'],
    ['medium', 'gap-medium'],
    ['large', 'gap-large'],
    ['xlarge', 'gap-xlarge'],
];
const DeprecatedAndPreferredValues = [...EGDSLayoutSpaceMap, ...EGDSLayoutSpaceDeprecatedValuesMap];
const EGDSLayoutSpaces = new Map(DeprecatedAndPreferredValues);
const EGDSLayoutFixedSizeMap = [
    ['zero', 'zero'],
    ['fifteen', 'fifteen'],
    ['sixteen', 'sixteen'],
    ['twenty_four', 'twenty_four'],
    ['seventy_two', 'seventy_two'],
    ['seventy_six', 'seventy_six'],
    ['eighty_eight', 'eighty_eight'],
    ['ninety_six', 'ninety_six'],
    ['one_hundred_four', 'one_hundred_four'],
    ['one_hundred_twelve', 'one_hundred_twelve'],
    ['one_hundred_twenty', 'one_hundred_twenty'],
];
const EGDSLayoutFixedSizes = new Map(EGDSLayoutFixedSizeMap);
const EGDSLayoutPercentageSizeMap = [
    ['full_width', 'full_width'],
    ['half_width', 'half_width'],
    ['third_width', 'third_width'],
    ['quarter_width', 'quarter_width'],
];
const EGDSLayoutPercentageSizes = new Map(EGDSLayoutPercentageSizeMap);
// To be deprecated
const EGDSLayoutSizeMap = [
    ['zero', 'zero'],
    ['fifteen', 'fifteen'],
    ['sixteen', 'sixteen'],
    ['twenty_four', 'twenty_four'],
    ['seventy_two', 'seventy_two'],
    ['seventy_six', 'seventy_six'],
    ['eighty_eight', 'eighty_eight'],
    ['ninety_six', 'ninety_six'],
    ['one_hundred_four', 'one_hundred_four'],
    ['one_hundred_twelve', 'one_hundred_twelve'],
    ['one_hundred_twenty', 'one_hundred_twenty'],
    ['full_width', 'full_width'],
    ['half_width', 'half_width'],
    ['third_width', 'third_width'],
    ['quarter_width', 'quarter_width'],
];
const EGDSLayoutSizes = new Map(EGDSLayoutSizeMap);
const EGDSLayoutTagMap = [
    ['article', 'article'],
    ['aside', 'aside'],
    ['div', 'div'],
    ['footer', 'footer'],
    ['header', 'header'],
    ['section', 'section'],
    ['ul', 'ul'],
    ['ol', 'ol'],
    ['li', 'li'],
    ['main', 'main'],
];
const EGDSLayoutTags = new Map(EGDSLayoutTagMap);

export { EGDSLayoutSpaces as E, EGDSLayoutFixedSizes as a, EGDSLayoutPercentageSizes as b, EGDSLayoutSizes as c, EGDSLayoutTags as d };
//# sourceMappingURL=index-chunk.esm2.js.map
